export default "__VITE_ASSET__156c461b__"